import React from 'react';
import 'react-fastclick';
import thunkMiddleware from 'redux-thunk';
import { applyMiddleware, createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';
import { render } from 'react-dom';
import { IndexRoute, Redirect, Router, Route, browserHistory } from 'react-router';
import { syncHistoryWithStore, routerReducer, routerMiddleware } from 'react-router-redux';
import $ from 'jquery';
import 'hudl-react-kickoff/legacy/lib/kickoff/layout-main';
import { data, model } from 'hudl-base';

import 'entries/video-page-video/utility/page-load';

import './author-profile-page.scss';
import 'react-select/dist/react-select.css';
import authorProfileApp from 'reducers/author-profile';
import UsageLogger from 'common/usage-logger';
import App from 'components/author-profile/app';
import AuthorTimelineTab from 'components/author-profile/timeline/author-timeline-tab';
import AuthorVideosTab from 'components/author-profile/videos/author-videos-tab';
import AuthorHighlightsTab from 'components/author-profile/highlights/author-highlights-tab';
import WebNav from 'components/shared/nav';
import g11n from 'hudl-g11n';
import * as HudlFeed from 'hudl-feed';
import loadAsyncScripts from 'common/async-scripts';
import promoteDynamicContent from 'utility/comscore';


$(() => {
  window.__hudlui_Generic && window.__hudlui_Generic.init();

  const usageLogger = new UsageLogger();
  const clientModel = model.get();
  const IntlProvider = g11n.ReactIntl.IntlProvider;

  const i18n = {
    locale: data.get('i18nLocale'),
    messages: data.get('i18nMessages'),
  };

  // Prevent the browser from going to the last scroll position
  const isMobile = clientModel.isMobile;
  if (!isMobile && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const defaultState = {
    bulkSaves: {
      isBulk: false,
    },
    customize: {
      color: {
        value: clientModel.author.primaryColor || null,
        saveSuccess: false,
        saveError: false,
        error: false,
      },
      profileImage: {
        value: clientModel.author.profileLogoUri,
      },
      bannerImage: {
        value: clientModel.author.profileBannerUri,
      },
      tagline: {
        value: clientModel.author.tagline,
        saveSuccess: false,
        saveError: false,
        error: false,
      },
    },
    feedback: {
      feedbackEnabled: clientModel.feedback.feedbackEnabled,
    },
    highlights: {
      sort: 'recent',
    },
    onboarding: {
      isDismissed: true,
      steps: [],
      currentStep: null,
    },
    videos: {
      sort: 'recent',
    },
    mediaSnowplowTrackerContext: clientModel.mediaSnowplowTrackerContext,
  };

  delete clientModel.feedback.feedbackEnabled;

  // The default selected season is the current one
  const { defaultState: defaultFeedState } = HudlFeed.store;

  // We use the jquery extend method in order to get a proper deep copy
  const initialState = $.extend(true, {}, defaultState, defaultFeedState, clientModel);

  const feedReducers = HudlFeed.reducers;
  const reducer = combineReducers(Object.assign({}, feedReducers, {
    routing: routerReducer,
  }, authorProfileApp));

  const createStoreWithMiddleware = applyMiddleware(routerMiddleware(browserHistory), thunkMiddleware)(createStore);

  const store = createStoreWithMiddleware(reducer, initialState);
  // Sync dispatched route actions to the history
  const history = syncHistoryWithStore(browserHistory, store);

  let firstView = true;
  history.listen(location => {
    // Don't log through google analytics on first page view since kickoff does that by default
    usageLogger.logHudlAccountLocation(location, initialState.author.hudlAccountId,
      initialState.author.isPerformanceCenterAccount, !firstView);
    firstView = false;
  });

  promoteDynamicContent(clientModel.comScoreId);

  const rootElement = document.getElementById('app');
  const loadingStateElement = document.getElementById('feed-loading-state');
  if (loadingStateElement) {
    loadingStateElement.style.display = 'none';
  }

  let videosTab;
  if (initialState.onlyVideos || initialState.highlightsAndVideos) {
    videosTab = <Route key="videos-tab-route" path="videos" component={AuthorVideosTab}/>;
  } else {
    videosTab = <Redirect key="videos-tab-route" from="videos" to="/page/:vanityUrl" />;
  }

  let highlightsTab;
  if (initialState.onlyHighlights) {
    highlightsTab = <Route key="highlights-tab-route" path="highlights" component={AuthorHighlightsTab}/>;
  } else {
    highlightsTab = <Redirect key="highlights-tab-route" from="highlights" to="/page/:vanityUrl" />;
  }

  render(
    <IntlProvider {...i18n}>
      <Provider store={store}>
        <Router history={history}>
          <Route path="/" component={WebNav}>
            <Route path="/page">
              <Route path=":vanityUrl" component={App}>
                <IndexRoute component={AuthorTimelineTab}/>
                <Redirect from="timeline" to="/page/:vanityUrl" />
                {videosTab}
                {highlightsTab}
                <Redirect from="library" to="/page/:vanityUrl/videos"/>
              </Route>
            </Route>
          </Route>
        </Router>
      </Provider>
    </IntlProvider>,
    rootElement,
    () => {
      if (!isMobile) {
        // Scroll part way down the header
        const scrollArea = document.querySelector('.parallax');
        if (scrollArea) {
          scrollArea.scrollTop = 270;
        }
      }
    });
  loadAsyncScripts();
});
